import axios from "axios";
import { API_HOST } from "@/core/variables";


const MAX_BULK_TEST_PAGE_SIZE = 50;

class BulkTestRepository {
    getScenarioTest = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/bulktest`, {
                params: {
                    page: 0,
                    size: MAX_BULK_TEST_PAGE_SIZE
                }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    getScenarioTestCase = async (scenarioId: string, scenarioTestId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/testing/${scenarioTestId}/case`, {
                responseType: "blob",
                headers: { "Cache-Control": "no-cache" }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    getScenarioTestResult = async (scenarioId: string, scenarioTestId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/testing/${scenarioTestId}/result`, {
                responseType: "blob",
                headers: { "Cache-Control": "no-cache" }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };
}

const bulkTestRepository = new BulkTestRepository();

export default bulkTestRepository; 